import * as actions from '@redux-actions/';

import {
    AccessTokenPayload,
    DoctorInfo,
    SyncEyeExamsPayload,
    IAddToCartPayload,
    IPrescriptionFileResponse,
    IMySavedPrescriptionsListPayload,
    IAddUpdatePrescriptionPayload,
    GetSKUPayload,
    UploadPrescriptionFilePayload,
} from '@interfaces/myAppointmentInterfaces';

import {
    mapContactLensDetails,
    mapSavedPrescriptionsList,
    mapDoctorList
} from '@utils/pages-utils/MyProfileUtils';

import URLS from '@utils/urlList';
import { getMockedFile } from '@utils/utils';

import axios, { AxiosRequestConfig } from 'axios';

//EYE EXAMS

export const getUserEyeExams = (isMockRequest: boolean, storeId: string, endPointStatusExams: string, difKey: string, authEncoded: string) => {
    if (isMockRequest) {
        const getUserEyeExams = '/data/mocks/my_appointments_get_user_eye_exams_mock.json';
        return dispatch => {
            dispatch(actions.getUserEyeExamsPending());
            getMockedFile(getUserEyeExams)
                .then(response => {
                    dispatch(
                        actions.getUserEyeExamsSuccess(response.data.response.data.appointment)
                    );
                })
                .catch(() => dispatch(actions.getUserEyeExamsError()));
        };
    } else {
        const getUserEyeExamsUrl = URLS.GET_USER_EYE_EXAMS.replace('{storeId}', storeId)
            .replace('{noCache}', new Date().getTime().toString());

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getUserEyeExamsUrl,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            dispatch(actions.getUserEyeExamsPending());
            axios(config)
                .then(response => {
                    let responseOfAppointment = response?.data?.response?.data?.appointment
                    const encApptIds = responseOfAppointment?.map(appointment => ({ "id": appointment.encApptId + "" }))

                    const configStatus: AxiosRequestConfig = {
                        method: 'POST',
                        url: endPointStatusExams,
                        headers: {
                            'Content-Type': 'application/json',
                            'Ocp-Apim-Subscription-Key': difKey,
                            'Authorization': 'Basic ' + authEncoded,
                            caller: 'rona',
                        },
                        data: encApptIds,
                    };

                    axios(configStatus)
                        .then(responseStatus => {
                            const appointmentsWithStatusMod = responseOfAppointment.map(appointment => {
                                const appointmentStatusFound = responseStatus.data.find(statusFound => statusFound.id === appointment.encApptId);

                                if (appointmentStatusFound) {
                                    return { ...appointment, status: appointmentStatusFound.status };
                                } else {
                                    return { ...appointment }
                                }
                            })

                            dispatch(
                                actions.getUserEyeExamsSuccess(appointmentsWithStatusMod)
                            );
                        })
                        .catch(() => {
                            console.log("fallback on appointments standard flow")
                            dispatch(actions.getUserEyeExamsSuccess(responseOfAppointment));
                        })
                })
                .catch(() => dispatch(actions.getUserEyeExamsError()));
        };
    }
};

export const getDoctorInfo = (
    isMockRequest: boolean,
    storeId: string,
    storeNumber: string,
    doctorId: string
) => {

    if (isMockRequest) {
        const getDoctorInfo = '/data/mocks/my_appointments_get_doctor_info_mock.json';
        return dispatch => {
            dispatch(actions.getDoctorInfoPending());
            getMockedFile(getDoctorInfo)
                .then(response => {
                    const doctors = response.data.response.data.doctors as DoctorInfo[];
                    const doctor = doctors.find(d => doctorId === d.doctorId);
                    doctor.languages = response.data.response.data.languages;

                    !!doctor
                        ? dispatch(actions.getDoctorInfoSuccess(doctor))
                        : dispatch(actions.getDoctorInfoError());
                })
                .catch(() => dispatch(actions.getDoctorInfoError()));
        };
    } else {
        const getDoctorInfoUrl = URLS.GET_DOCTOR_INFO.replace('{storeId}', storeId).replace(
            '{storeNumber}',
            storeNumber
        );

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getDoctorInfoUrl,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            //dispatch deletion to avoid component update 
            // dispatch(actions.getUserEyeExamsPending()); 
            axios(config)
                .then(response => {
                    const doctors = response?.data?.response?.data?.doctors as DoctorInfo[];
                    const doctor = doctors.find(d => doctorId === d.doctorId);
                    doctor.languages = response.data.response.data.languages;

                    !!doctor
                        ? dispatch(actions.getDoctorInfoSuccess(doctor))
                        : dispatch(actions.getDoctorInfoError());
                    //dispatch deletion to avoid component update 
                    // dispatch(

                    //    actions.getUserEyeExamsSuccess(response?.data?.response?.data?.appointment) 
                    // );
                })
                .catch(() => dispatch(actions.getUserEyeExamsError()));
        };
    }
};

export const deleteUserEyeExam = (
    isMockRequest: boolean,
    storeId: string,
    appointmentId: number,
    endPointStatusExams: string,
    difKey: string,
    authEncoded: string
) => {
    const deleteUserEyeExamUrl = URLS.DELETE_USER_EYE_EXAM.replace('{storeId}', storeId)
        .replace('{appointmentId}', appointmentId.toString())
        .replace('{noCache}', new Date().getTime().toString());

    const config: AxiosRequestConfig = {
        method: 'DELETE',
        url: deleteUserEyeExamUrl,
        headers: { 'Content-Type': 'application/json' },
    };

    return dispatch => {
        dispatch(actions.deleteEyeExamPending());
        axios(config)
            .then(() => {
                dispatch(actions.deleteEyeExamSuccess());
                dispatch(getUserEyeExams(isMockRequest, storeId, endPointStatusExams, difKey, authEncoded));
            })
            .catch(() => dispatch(actions.deleteEyeExamError()));
    };
};

export const syncMyEyeExams = (payload: SyncEyeExamsPayload, endPointStatusExams: string, difKey: string, authEncoded: string) => {
    const syncMyEyeExamsUrl = URLS.SYNC_EYE_EXAM.replace(
        '{storeId}',
        payload.storeId.toString()
    );

    const config: AxiosRequestConfig = {
        method: 'POST',
        url: syncMyEyeExamsUrl,
        headers: { 'Content-Type': 'application/json' },
        data: payload,
    };

    return dispatch => {
        dispatch(actions.syncMyEyeExamsPending);
        axios(config)
            .then(() => {
                setTimeout(() => {
                    dispatch(actions.syncMyEyeExamsSuccess());
                    dispatch(getUserEyeExams(false, payload.storeId.toString(), endPointStatusExams, difKey, authEncoded));
                }, 10000);
            })
            .catch(() => dispatch(actions.syncMyEyeExamsError()));
    };
};

//IN-STORE SERVICES

export const getAccessToken = (payload: AccessTokenPayload) => {
    const { isMockRequest, storeId, ...rest } = payload;

    if (isMockRequest) {
        const accessToken =
            '/data/mocks/my_appointments_in_store_services_get_access_token_mock.json';
        return dispatch => {
            dispatch(actions.getAccessTokenPending());
            getMockedFile(accessToken)
                .then(result => {
                    dispatch(actions.getAccessTokenSuccess(result?.data?.jwtToken?.jwtToken));
                })
                .catch(() => dispatch(actions.getAccessTokenError()));
        };
    } else {
        const accessTokenUrl = URLS.GET_ACCESS_TOKEN.replace(
            '{storeId}',
            storeId.toString()
        ).replace('{noCache}', new Date().getTime().toString());

        const config: AxiosRequestConfig = {
            method: 'POST',
            url: accessTokenUrl,
            headers: { Caller: 'rona', 'Content-Type': 'application/json' },
            data: rest,
        };

        return dispatch => {
            dispatch(actions.getAccessTokenPending());
            axios(config)
                .then(result => {
                    dispatch(actions.getAccessTokenSuccess(result?.data?.jwtToken?.jwtToken));
                })
                .catch(() => dispatch(actions.getAccessTokenError()));
        };
    }
};

export const addToBagService = (
    storeId: string,
    catalogId: string,
    langId: string,
    payload: IAddToCartPayload
) => {
    const { isMockRequest, ...data } = payload;

    var formBody = [];
    for (var property in data) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(data[property]);
        formBody.push(encodedKey + '=' + encodedValue);
    }
    const dataBody = formBody.join('&');

    if (isMockRequest) {
        return dispatch => {
            dispatch(actions.addToCartSuccess());
        };
    } else {
        const addToCartUrl = URLS.ADD_TO_BAG;

        const config: AxiosRequestConfig = {
            method: 'POST',
            url: addToCartUrl,
            //headers: { 'Content-Type': 'application/json' },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: dataBody,
        };

        return dispatch => {
            dispatch(actions.addToCartPending());
            axios(config)
                .then(result => {
                    dispatch(actions.addToCartSuccess());
                    window.location.href = URLS.REDIRECT_TO_CART.replace('{storeId}', storeId)
                        .replace('{catalogId}', catalogId)
                        .replace('{langId}', langId);
                })
                .catch(() => dispatch(actions.addToCartError()));
        };
    }
};


export const reorderContactRetailService = (
    storeId: string,
    catalogId: string,
    langId: string,
    payload: IAddToCartPayload,
) => {
    const { isMockRequest, ...data } = payload;

    var formBody = [];
    for (var property in data) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(data[property]);
        formBody.push(encodedKey + '=' + encodedValue);
    }
    const dataBody = formBody.join('&');

    if (isMockRequest) {
        return dispatch => {
            dispatch(actions.addToCartSuccess());
        };
    } else {
        let addToCartUrl = URLS.ADD_TO_BAG;
        if(typeof addToCartUrl ===  'undefined'){
                console.error('addTocartUrl is undefined');
                addToCartUrl = '/webapp/wcs/stores/servlet/OrderItemAddContactLensesCmd';
        }

        const config: AxiosRequestConfig = {
            method: 'POST',
            url: addToCartUrl,
            //headers: { 'Content-Type': 'application/json' },
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: dataBody,
        };
        
        return dispatch => {
        dispatch(actions.addToCartPending());
        axios(config)
            .then(result => {
                dispatch(actions.addToCartSuccess());
                 try{
                    sessionStorage.setItem("isReorderFlow", true);
                    sessionStorage.setItem("isReorderFlowRetail", true);
                    window.location.href = "/SummaryView?reorder=true&mode=payment&fromDoctorInfo=1&storeId="+storeId+"&catalogId="+catalogId+"&langId=-1&fromPage=fromShippingMethod";
                } catch(e) {
                    console.error(e); 
                }
            })
            .catch(() => dispatch(actions.addToCartError()));
        };
    }
};


export const downloadPrescriptionFile = async (
    isMockRequest: boolean,
    storeId: string,
    fileName: string
): Promise<IPrescriptionFileResponse> => {
    return new Promise((resolve, reject) => {
        if (isMockRequest) {
            const downloadFileMock =
                '/data/mocks/my_prescription_download_prescription_file_mock.json';

            getMockedFile(downloadFileMock)
                .then(response => {
                    resolve(response.data);
                })
                .catch((error: any) => {
                    reject(error.response);
                });
        } else {
            const downloadFileUrl = URLS.DOWNLOAD_PRESCRIPTION_FILE.replace('{storeId}', storeId)
                .replace('{fileName}', fileName)
                .replace('{noCache}', new Date().getTime().toString());

            const config: AxiosRequestConfig = {
                method: 'GET',
                url: downloadFileUrl,
                headers: { 'Content-Type': 'application/json' },
            };

            axios(config)
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((error: any) => {
                    reject(error.response);
                });
        }
    });
};

export const getCLDetailsSingle = (
    isMockRequest: boolean,
    storeId: string,
    catalogId: string,
    productId: string
) => {
    return new Promise((resolve, reject) => {
        if (isMockRequest) {
            const clDetails = '/data/mocks/my_prescription_get_cl_details_single_mock.json';

            getMockedFile(clDetails)
                .then(result => {
                    const mappedResult = mapContactLensDetails(result?.data?.catalogEntry);
                    resolve(mappedResult);
                })
                .catch((err: any) => {
                    reject(err.response);
                });
        } else {
            const getPersonalDetailsUrl = URLS.GET_CL_DETAILS.replace('{storeId}', storeId)
                .replace('{catalogId}', catalogId)
                .replace('{productId}', productId)
                .replace('{noCache}', new Date().getTime().toString());

            const config: AxiosRequestConfig = {
                method: 'GET',
                url: getPersonalDetailsUrl,
                headers: { 'Content-Type': 'application/json' },
            };

            axios(config)
                .then(result => {
                    const mappedResult = mapContactLensDetails(result?.data?.catalogEntry);
                    resolve(mappedResult);
                })
                .catch((err: any) => {
                    reject(err.response);
                });
        }
    });
};

////////// MY PRESCRIPTIONS //////////

export const getMySavedPrescriptions = (payload: IMySavedPrescriptionsListPayload) => {
    const { isMockRequest, storeId } = payload;

    const handleGetMySavedPrescriptionsPromise = (dispatch: any, promise: Promise<any>) => {
        dispatch(actions.getMySavedPrescriptionsPending());

        promise
            .then(result => {
                if (result?.data?.resultList?.length > 0) {
                    const mappedSavedPrescriptions = mapSavedPrescriptionsList(
                        result?.data?.resultList
                    );

                    mappedSavedPrescriptions.sort((a, b) => new Date(b.lastUpdate).getTime() - new Date(a.lastUpdate).getTime())
                    dispatch(actions.getMySavedPrescriptionsSuccess(mappedSavedPrescriptions));
                } else {
                    dispatch(actions.getMySavedPrescriptionsError());
                    dispatch(actions.getMySavedPrescriptionsSuccess(null));
                }
            })
            .catch(() => dispatch(actions.getMySavedPrescriptionsError()));
    };

    const handleGetMySavedPrescriptionsPromiseMock = (dispatch: any, result: any) => {
        dispatch(actions.getMySavedPrescriptionsPending());

        if (result?.resultList?.length > 0) {
            const mappedSavedPrescriptions = mapSavedPrescriptionsList(
                result?.resultList
            );

            dispatch(actions.getMySavedPrescriptionsSuccess(mappedSavedPrescriptions));
        } else {
            dispatch(actions.getMySavedPrescriptionsError());
            dispatch(actions.getMySavedPrescriptionsSuccess(null));
        }
    };

    if (isMockRequest) {
        // const jsonString = `{"resultList":[{"prescriptionId":1020474374404,"clinic":null,"prescriptionType":"ST","checksum":null,"segmentHeight":null,"buyableCLRight":true,"rightCyl":null,"doctor":null,"osNear":null,"verified":true,"userId":-1002,"brandCLLeft":"AirOptix HydGlyd Ast","rightCatentryParentId":null,"birthDate":"1952-03-14 00:00:00","prescriptionOrigin":"RETAIL","rightPicture":null,"lastName":"King","doctorFax":null,"expiration":"2025-02-01 00:00:00","nickname":null,"osOcHeight":null,"odVPrismBaseDir":null,"osSegHeight":null,"lpDistance":null,"buyableCLLeft":false,"odFar":null,"leftPicture":null,"doctorAddress":null,"odHPrism":null,"odOcHeight":null,"osVPrismBaseDir":null,"frameRearVetexDistance":null,"rightSphere":"2.5","fileName":null,"osHPrism":null,"leftCatentryId":null,"comment":null,"markIfDeleted":false,"leftAdd":null,"prescriptionOriginMode":"retailPrescription","rightAdd":"0.0","sameParent":"false","leftCyl":"-0.75","hasRelatedOrderPrescriptions":false,"lastUpdate":"2024-02-02 00:00:00","prismEnable":"false","productCategory":"CONTACTS","issue":null,"rpDistance":null,"statePrescription":null,"osFar":null,"leftSphere":"3.25","odNear":null,"odVPrism":null,"isVisible":true,"osVPrism":null,"frameWrap":null,"rightAxis":null,"firstName":"Sam","brandCLRight":"AirOptix HydGlyde MF","leftAxis":"150.0","nameCLRight":"AOPHMF6P 8.6 14.2 VISI","odHPrismBaseDir":null,"rightCatentryId":null,"odSegHeight":null,"lastCreate":"2024-02-02 00:00:00","nameCLLeft":"AOHAS6P 8.7 14.5 VISI +03.25","ocularCenter":null,"framePantoTilt":null,"pupillaryDistance":null,"prescriptionClass":"RETAIL","prescriptionName":"King Sam 02/02/2024","leftCatentryParentId":null,"osHPrismBaseDir":null,"telephone":null,"rightDia":"14.5","leftDia":"14.5","rightBC":"8.5","leftBC":"8.5","price":"25,99"},{"prescriptionId":1021432294404,"clinic":null,"prescriptionType":"ST","checksum":null,"segmentHeight":null,"rightCyl":"-5.0","doctor":null,"osNear":null,"verified":true,"userId":1158506,"birthDate":"2006-09-27 00:00:00","prescriptionOrigin":"RETAIL","lastName":"Roman","doctorFax":null,"nickname":null,"expiration":"2026-03-27 00:00:00","osOcHeight":"35.6","odVPrismBaseDir":null,"lpDistance":"30.7","osSegHeight":null,"odFar":"29.8","doctorAddress":null,"odHPrism":null,"odOcHeight":"34.6","osVPrismBaseDir":null,"frameRearVetexDistance":"19.6","rightSphere":"4.0","fileName":null,"osHPrism":null,"comment":null,"markIfDeleted":false,"leftAdd":null,"prescriptionOriginMode":"retailPrescription","rightAdd":null,"leftCyl":"-1.75","hasRelatedOrderPrescriptions":false,"lastUpdate":"2024-03-27 00:00:00","prismEnable":"false","productCategory":"GLASSES","issue":null,"rpDistance":"29.8","osFar":"30.7","statePrescription":null,"leftSphere":"2.5","odNear":null,"isVisible":true,"odVPrism":null,"osVPrism":null,"frameWrap":"7.2","rightAxis":"161.0","firstName":"Saray","leftAxis":"14.0","odHPrismBaseDir":null,"odSegHeight":null,"lastCreate":"2024-03-27 00:00:00","ocularCenter":null,"framePantoTilt":"13.2","pupillaryDistance":"29.8","prescriptionClass":"RETAIL","prescriptionName":"Roman Saray 03/27/2024","telephone":null,"osHPrismBaseDir":null}]}`;

        // Same Parent True
        const jsonString = `{"resultList":[{"prescriptionId":"1020474374404","clinic":null,"prescriptionType":"ST","checksum":null,"segmentHeight":null,"buyableCLRight":true,"rightCyl":null,"doctor":null,"osNear":null,"verified":true,"userId":-1002,"brandCLLeft":null,"rightCatentryParentId":109201,"birthDate":"1952-03-14 00:00:00","prescriptionOrigin":"RETAIL","rightPicture":null,"lastName":"King","doctorFax":null,"expiration":"2025-02-01 00:00:00","nickname":null,"osOcHeight":null,"odVPrismBaseDir":null,"osSegHeight":null,"lpDistance":null,"buyableCLLeft":false,"odFar":null,"leftPicture":null,"doctorAddress":null,"odHPrism":null,"odOcHeight":null,"osVPrismBaseDir":null,"frameRearVetexDistance":null,"rightSphere":"2.5","fileName":null,"osHPrism":null,"leftCatentryId":109212,"comment":null,"markIfDeleted":false,"leftAdd":"0.0","prescriptionOriginMode":"retailPrescription","rightAdd":"0.0","sameParent":"true","leftCyl":null,"hasRelatedOrderPrescriptions":false,"lastUpdate":"2024-02-02 00:00:00","prismEnable":"false","productCategory":"CONTACTS","issue":null,"rpDistance":null,"statePrescription":null,"osFar":null,"leftSphere":"2.5","odNear":null,"odVPrism":null,"isVisible":true,"osVPrism":null,"frameWrap":null,"rightAxis":null,"firstName":"Sam","brandCLRight":"AirOptix HydGlyde MF","leftAxis":null,"nameCLRight":"AOPHMF6P 8.6 14.2 VISI","odHPrismBaseDir":null,"rightCatentryId":109212,"odSegHeight":null,"lastCreate":"2024-02-02 00:00:00","nameCLLeft":null,"ocularCenter":null,"framePantoTilt":null,"pupillaryDistance":null,"prescriptionClass":"RETAIL","prescriptionName":"King Sam 02/02/2024","leftCatentryParentId":109201,"osHPrismBaseDir":null,"telephone":null,"rightDia":"14.5","leftDia":"14.5","rightBC":"8.5","leftBC":"8.5","price":"25,99"},{"prescriptionId":1021432294404,"clinic":null,"prescriptionType":"ST","checksum":null,"segmentHeight":null,"rightCyl":"-5.0","doctor":null,"osNear":null,"verified":true,"userId":1158506,"birthDate":"2006-09-27 00:00:00","prescriptionOrigin":"RETAIL","lastName":"Roman","doctorFax":null,"nickname":null,"expiration":"2026-03-27 00:00:00","osOcHeight":"35.6","odVPrismBaseDir":null,"lpDistance":"30.7","osSegHeight":null,"odFar":"29.8","doctorAddress":null,"odHPrism":null,"odOcHeight":"34.6","osVPrismBaseDir":null,"frameRearVetexDistance":"19.6","rightSphere":"4.0","fileName":null,"osHPrism":null,"comment":null,"markIfDeleted":false,"leftAdd":null,"prescriptionOriginMode":"retailPrescription","rightAdd":null,"leftCyl":"-1.75","hasRelatedOrderPrescriptions":false,"lastUpdate":"2024-03-27 00:00:00","prismEnable":"false","productCategory":"GLASSES","issue":null,"rpDistance":"29.8","osFar":"30.7","statePrescription":null,"leftSphere":"2.5","odNear":null,"isVisible":true,"odVPrism":null,"osVPrism":null,"frameWrap":"7.2","rightAxis":"161.0","firstName":"Saray","leftAxis":"14.0","odHPrismBaseDir":null,"odSegHeight":null,"lastCreate":"2024-03-27 00:00:00","ocularCenter":null,"framePantoTilt":"13.2","pupillaryDistance":"29.8","prescriptionClass":"RETAIL","prescriptionName":"Roman Saray 03/27/2024","telephone":null,"osHPrismBaseDir":null}]}`;

        return dispatch => {
            handleGetMySavedPrescriptionsPromiseMock(dispatch, JSON.parse(jsonString));
        };
    } else {
        const mySavedPrescriptionsUrl = URLS.GET_MY_SAVED_PRESCRIPTIONS.replace(
            '{storeId}',
            storeId.toString()
        ).replace('{noCache}', new Date().getTime().toString());
        /*
        .replace('{pageSize}','0')
        .replace('{pageNumber}','0')
        */

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: mySavedPrescriptionsUrl,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            handleGetMySavedPrescriptionsPromise(dispatch, axios(config));
        };
    }
};

export const addPrescription = async (storeId: string, payload: IAddUpdatePrescriptionPayload) => {
    return new Promise((resolve, reject) => {
        const addPrescriptionUrl = URLS.SET_MY_SAVED_PRESCRIPTION.replace('{storeId}', storeId);

        const config: AxiosRequestConfig = {
            method: 'POST',
            url: addPrescriptionUrl,
            headers: { 'Content-Type': 'application/json' },
            data: payload,
        };

        axios(config)
            .then((res: any) => {
                resolve(res);
            })
            .catch((err: any) => {
                reject(err.response);
            });
    });
};

export const editPrescription = async (
    storeId: string,
    prescriptionId: string,
    payload: IAddUpdatePrescriptionPayload
) => {
    return new Promise((resolve, reject) => {
        const editPrescriptionUrl = URLS.EDIT_MY_SAVED_PRESCRIPTION.replace(
            '{storeId}',
            storeId
        ).replace('{prescriptionId}', prescriptionId);

        const config: AxiosRequestConfig = {
            method: 'POST',
            url: editPrescriptionUrl,
            headers: { 'Content-Type': 'application/json' },
            data: payload,
        };

        axios(config)
            .then((res: any) => {
                resolve(res);
            })
            .catch((err: any) => {
                reject(err.response);
            });
    });
};

export const removePrescription = (
    isMockRequest: boolean,
    storeId: string,
    deletePrescriptionId: string
) => {
    if (isMockRequest) {
        return dispatch => {
            dispatch(actions.removeMySavedPrescriptionSuccess());
        };
    }

    const removePrescriptionUrl = URLS.REMOVE_PRESCRIPTION.replace('{storeId}', storeId).replace(
        '{prescriptionId}',
        deletePrescriptionId
    );

    const config: AxiosRequestConfig = {
        method: 'PUT',
        url: removePrescriptionUrl,
        headers: { 'Content-Type': 'application/json' },
    };

    return dispatch => {
        dispatch(actions.removeMySavedPrescriptionPending());

        axios(config)
            .then(
                () =>
                    dispatch(
                        getMySavedPrescriptions({ isMockRequest: isMockRequest, storeId: +storeId })
                    ),
                dispatch(actions.removeMySavedPrescriptionSuccess())
            )
            .catch(() => dispatch(actions.removeMySavedPrescriptionError()));
    };
};

export const hidePrescription = (
    isMockRequest: boolean,
    storeId: string,
    deletePrescriptionId: string
) => {
    if (isMockRequest) {
        return dispatch => {
            dispatch(actions.removeMySavedPrescriptionSuccess());
        };
    }

    const removePrescriptionUrl = URLS.LOGIC_REMOVE_PRESCRIPTION.replace('{storeId}', storeId).replace(
        '{prescriptionId}',
        deletePrescriptionId
    );

    const config: AxiosRequestConfig = {
        method: 'PUT',
        url: removePrescriptionUrl,
        headers: { 'Content-Type': 'application/json' },
    };

    return dispatch => {
        dispatch(actions.removeMySavedPrescriptionPending());

        axios(config)
            .then(
                () =>
                    dispatch(
                        getMySavedPrescriptions({ isMockRequest: isMockRequest, storeId: +storeId })
                    ),
                dispatch(actions.removeMySavedPrescriptionSuccess())
            )
            .catch(() => dispatch(actions.removeMySavedPrescriptionError()));
    };
};

export const getCLDetails = (
    isMockRequest: boolean,
    storeId: string,
    catalogId: string,
    productId: string,
    right: boolean,
    checkedDifferentCL: boolean
) => {
    if (isMockRequest) {
        const clDetails = '/data/mocks/my_prescription_get_cl_details_mock.json';
        const clDetails2 = '/data/mocks/my_prescription_get_cl_details_mock2.json';
        return dispatch => {
            if (right) {
                dispatch(actions.getClDetailsRightPending());
                if (!checkedDifferentCL) {
                    dispatch(actions.getClDetailsRightPending());
                }
            } else {
                dispatch(actions.getClDetailsLeftPending());
            }

            getMockedFile(clDetails)
                .then(result => {
                    const mappedResult = mapContactLensDetails(result?.data?.catalogEntry);

                    if (right) {
                        dispatch(actions.getClDetailsRightSuccess(mappedResult));
                        if (!checkedDifferentCL) {
                            dispatch(actions.getClDetailsLeftSuccess(mappedResult));
                        }
                    } else {
                        dispatch(actions.getClDetailsLeftSuccess(mappedResult));
                    }
                })
                .catch(() => {
                    if (right) {
                        dispatch(actions.getClDetailsRightError());
                    } else {
                        dispatch(actions.getClDetailsLeftError());
                    }
                });
        };
    } else {
        const getPersonalDetailsUrl = URLS.GET_CL_DETAILS.replace('{storeId}', storeId)
            .replace('{catalogId}', catalogId)
            .replace('{productId}', productId)
            .replace('{noCache}', new Date().getTime().toString());

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getPersonalDetailsUrl,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            if (right) {
                dispatch(actions.getClDetailsRightPending());
                if (!checkedDifferentCL) {
                    dispatch(actions.getClDetailsRightPending());
                }
            } else {
                dispatch(actions.getClDetailsLeftPending());
            }

            axios(config)
                .then(result => {
                    const mappedResult = mapContactLensDetails(result?.data?.catalogEntry);

                    if (right) {
                        dispatch(actions.getClDetailsRightSuccess(mappedResult));
                        if (!checkedDifferentCL) {
                            dispatch(actions.getClDetailsLeftSuccess(mappedResult));
                        }
                    } else {
                        dispatch(actions.getClDetailsLeftSuccess(mappedResult));
                    }
                })
                .catch(() => {
                    if (right) {
                        dispatch(actions.getClDetailsRightError());
                    } else {
                        dispatch(actions.getClDetailsLeftError());
                    }
                });
        };
    }
};

export const getHowToReadEspotCl = (isMockRequest: boolean, storeId: string) => {
    if (isMockRequest) {
        const getHowToReadEspotMock = '/data/mocks/my_profile_get_how_to_read_espot_cl_mock.json';
        return dispatch => {
            dispatch(actions.getHowToReadEspotClPending());
            getMockedFile(getHowToReadEspotMock)
                .then(response => {
                    dispatch(
                        actions.getHowToReadEspotClSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0].marketingContentDescription?.[0].marketingText?.replace(
                                /\\/g,
                                ''
                            )
                        )
                    );
                })
                .catch(err => dispatch(actions.getHowToReadEspotClError()));
        };
    } else {
        const getHowToReadEspotURL = URLS.GET_HOW_TO_READ_ESPOT_CL.replace(
            '{storeId}',
            storeId
        ).replace('{noCache}', new Date().getTime().toString());

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getHowToReadEspotURL,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            dispatch(actions.getHowToReadEspotClPending());
            axios(config)
                .then(response => {
                    dispatch(
                        actions.getHowToReadEspotClSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0]
                                .marketingContentDescription?.[0].marketingText
                        )
                    );
                })
                .catch(() => dispatch(actions.getHowToReadEspotClError()));
        };
    }
};

// if (true) {
//     const jsonString = `{"data":{"productId":109212}}`;
//     const jsonMock = JSON.parse(jsonString);

//     resolve(jsonMock);
// } else {

export const getSKU = async (
    storeId: string,
    catalogId: string,
    parentProductId: string,
    payload: GetSKUPayload
) => {
    return new Promise((resolve, reject) => {
        const getSkuUrl = URLS.GET_SKU_CL.replace('{storeId}', storeId)
            .replace('{catalogId}', catalogId)
            .replace('{parentProductId}', parentProductId);

        const config: AxiosRequestConfig = {
            method: 'POST',
            url: getSkuUrl,
            headers: { 'Content-Type': 'application/json' },
            data: payload,
        };

        axios(config)
            .then((res: any) => {
                resolve(res);
            })
            .catch((err: any) => {
                reject(err.response);
            });
    });
};

export const uploadPrescriptionFile = async (
    storeId: string,
    payload: UploadPrescriptionFilePayload
) => {
    return new Promise((resolve, reject) => {
        const uploadFileUrl = URLS.UPLOAD_PRESCRIPTION_FILE.replace('{storeId}', storeId);

        const config: AxiosRequestConfig = {
            method: 'POST',
            url: uploadFileUrl,
            headers: { 'Content-Type': 'application/json' },
            data: payload,
        };

        axios(config)
            .then((res: any) => {
                resolve(res);
            })
            .catch((err: any) => {
                reject(err.response);
            });
    });
};

export const getDoctorService = (isMockRequest: boolean, storeId: string, searchTerm: string) => {
    if (isMockRequest) {
        const getDoctorMock = '/data/mocks/my_profile_get_doctor_mock.json';
        return dispatch => {
            dispatch(actions.getDoctorPending());
            getMockedFile(getDoctorMock)
                .then(response => {
                    if (response.data.response.status !== 'Success') {
                        dispatch(actions.getDoctorError());
                        return;
                    }

                    const mappedResult = mapDoctorList(response.data.response.data);
                    dispatch(actions.getDoctorSuccess(mappedResult));
                })
                .catch(err => dispatch(actions.getDoctorError()));
        };
    } else {
        const getDoctorURL = URLS.GET_DOCTOR.replace('{storeId}', storeId)
            .replace('{searchTerm}', searchTerm)
            .replace('{noCache}', new Date().getTime().toString());

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getDoctorURL,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            dispatch(actions.getDoctorPending());
            axios(config)
                .then(response => {
                    if (response.data.response.status !== 'Success') {
                        dispatch(actions.getDoctorError());
                        return;
                    }

                    const mappedResult = mapDoctorList(response.data.response.data);
                    dispatch(actions.getDoctorSuccess(mappedResult));
                })
                .catch(() => dispatch(actions.getDoctorError()));
        };
    }
};

export const getPrescriptionDefault = (isMockRequest: boolean, storeId: string) => {
    return new Promise((resolve, reject) => {
        const getPrescriptionDefaultURL = URLS.GET_DEFAULT_PRESCRIPTIONS.replace(
            '{storeId}',
            storeId
        ).replace('{noCache}', new Date().getTime().toString());

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getPrescriptionDefaultURL,
            headers: { 'Content-Type': 'application/json' },
        };

        axios(config)
            .then(result => {
                const mappedResult = result?.data;
                resolve(mappedResult);
            })
            .catch((err: any) => {
                reject(err.response);
            });
    })
}

export const setPrescriptionDefault = async (
    storeId: string,
    action: string,
    categoryPrescription: string,
    prescriptionId: string,
) => {
    return new Promise((resolve, reject) => {
        const setDefaultPrescriptionUrl = URLS.SET_DEFAULT_PRESCRIPTION.replace('{storeId}', storeId)
            .replace('{action}', action)
            .replace('{categoryPrescription}', categoryPrescription)
            .replace('{prescriptionId}', prescriptionId);

        const config: AxiosRequestConfig = {
            method: 'POST',
            url: setDefaultPrescriptionUrl,
            headers: { 'Content-Type': 'application/json' },
        };

        axios(config)
            .then((res: any) => {
                resolve(res);
            })
            .catch((err: any) => {
                reject(err.response);
            });
    });
};

export const deletePrescriptionDefault = async (
    storeId: string,
    action: string,
    categoryPrescription: string,
    prescriptionId: string,
) => {
    return new Promise((resolve, reject) => {
        const setDefaultPrescriptionUrl = URLS.SET_DEFAULT_PRESCRIPTION.replace('{storeId}', storeId)
            .replace('{action}', action)
            .replace('{categoryPrescription}', categoryPrescription)
            .replace('{prescriptionId}', prescriptionId);

        const config: AxiosRequestConfig = {
            method: 'DELETE',
            url: setDefaultPrescriptionUrl,
            headers: { 'Content-Type': 'application/json' },
        };

        axios(config)
            .then((res: any) => {
                resolve(res);
            })
            .catch((err: any) => {
                reject(err.response);
            });
    });
};

////////// E-SPOTS //////////

export const getPDEspot = (isMockRequest: boolean, storeId: string) => {
    if (isMockRequest) {
        const getPDEspotMock = '/data/mocks/my_profile_get_pd_espot_mock.json';
        return dispatch => {
            dispatch(actions.getPDEspotPending());
            getMockedFile(getPDEspotMock)
                .then(response => {
                    dispatch(
                        actions.getPDEspotSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0].marketingContentDescription?.[0].marketingText?.replace(
                                /\\/g,
                                ''
                            )
                        )
                    );
                })
                .catch(() => dispatch(actions.getPDEspotError()));
        };
    } else {
        const getPDEspotURL = URLS.GET_PD_ESPOT.replace('{storeId}', storeId).replace(
            '{noCache}',
            new Date().getTime().toString()
        );

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getPDEspotURL,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            dispatch(actions.getPDEspotPending());
            axios(config)
                .then(response => {
                    dispatch(
                        actions.getPDEspotSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0]
                                .marketingContentDescription?.[0].marketingText
                        )
                    );
                })
                .catch(() => dispatch(actions.getPDEspotError()));
        };
    }
};

export const getHowToReadEspot = (isMockRequest: boolean, storeId: string) => {
    if (isMockRequest) {
        const getHowToReadEspotMock = '/data/mocks/my_profile_get_how_to_read_espot_mock.json';
        return dispatch => {
            dispatch(actions.getHowToReadEspotPending());
            getMockedFile(getHowToReadEspotMock)
                .then(response => {
                    dispatch(
                        actions.getHowToReadEspotSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0].marketingContentDescription?.[0].marketingText?.replace(
                                /\\/g,
                                ''
                            )
                        )
                    );
                })
                .catch(err => dispatch(actions.getHowToReadEspotError()));
        };
    } else {
        const getHowToReadEspotURL = URLS.GET_HOW_TO_READ_ESPOT.replace(
            '{storeId}',
            storeId
        ).replace('{noCache}', new Date().getTime().toString());

        const config: AxiosRequestConfig = {
            method: 'GET',
            url: getHowToReadEspotURL,
            headers: { 'Content-Type': 'application/json' },
        };

        return dispatch => {
            dispatch(actions.getHowToReadEspotPending());
            axios(config)
                .then(response => {
                    dispatch(
                        actions.getHowToReadEspotSuccess(
                            response.data?.MarketingSpotData?.[0].baseMarketingSpotActivityData?.[0]
                                .marketingContentDescription?.[0].marketingText
                        )
                    );
                })
                .catch(() => dispatch(actions.getHowToReadEspotError()));
        };
    }
};